__turbopack_context__.v({
  "footer": "SignUp-module-scss-module__Crbcsq__footer",
  "form": "SignUp-module-scss-module__Crbcsq__form",
  "policy": "SignUp-module-scss-module__Crbcsq__policy",
});
